/** Parse one CSV line with quoted fields (promedhis nomenclature importer). */
export function parseCsvLine(line, delimiter = ',') {
  const result = [];
  let current = '';
  let inQuotes = false;
  let i = 0;

  while (i < line.length) {
    const char = line[i];
    const nextChar = line[i + 1];

    if (char === '"' && nextChar === '"' && inQuotes) {
      current += '"';
      i += 2;
      continue;
    }
    if (char === '"') {
      inQuotes = !inQuotes;
      i++;
      continue;
    }
    if (char === delimiter && !inQuotes) {
      result.push(current);
      current = '';
      i++;
      continue;
    }
    current += char;
    i++;
  }
  result.push(current);
  return result;
}

export function detectDelimiter(headerLine) {
  const tabs = (headerLine.match(/\t/g) || []).length;
  let commas = 0;
  let inQuotes = false;
  for (const ch of headerLine) {
    if (ch === '"') inQuotes = !inQuotes;
    else if (ch === ',' && !inQuotes) commas += 1;
  }
  return tabs >= commas ? '\t' : ',';
}

export function parseCsvTextToRows(csvData) {
  const rows = String(csvData || '')
    .split(/\r?\n/)
    .filter((row) => row.trim() !== '');
  if (!rows.length) {
    return { headers: [], dataRows: [] };
  }
  const delimiter = detectDelimiter(rows[0]);
  const parsed = rows.map((row) => parseCsvLine(row, delimiter));
  return { headers: parsed[0], dataRows: parsed.slice(1) };
}
